<template>
  <div>
    <b-row>
      <b-col cols="12">
        <h4>Responsáveis</h4>
        <fieldset class="font-weight-bold text-muted small">
          Cadastre os responsáveis e as cobranças por departamento
        </fieldset>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <hr
          class="mx-0 mt-0 mb-2"
          style="border-top: 1px solid #a3a4a66b !important;"
        >
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <responsavel-departamento-row
          v-for="(item, $index) in departamentos"
          :key="$index"
          v-model="departamentos[$index]"
          @novo="novoDepartamentoResponsavel"
          @remove="removeDepartamentoResponsavel"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ResponsavelDepartamento',
  components: {
    ResponsavelDepartamentoRow: () => import('./responsavel-departamento-row/ResponsavelDepartamentoRow.vue'),
  },
  computed: {
    ...mapGetters('empresa', ['empresa']),
    departamentos: {
      get() {
        return this.$store.getters['empresa/departamentos']
      },
      set(value) {
        this.$set(this.empresa, 'departamentos', value)
      },
    },
  },
  created() {
    if (this.empresa.departamentos.length === 0) {
      this.adicionaResponsaveisDepartamento()
    }
  },
  methods: {
    ...mapActions('empresa', ['adicionaResponsaveisDepartamento']),
    novoDepartamentoResponsavel() {
      this.adicionaResponsaveisDepartamento()
      this.adicionaComoPrimeiro()
    },
    removeDepartamentoResponsavel(value) {
      const index = this.departamentos
        .findIndex(f => (f.code && value.code === f.code) || (!f.code && f.id === value.id))
      this.departamentos.splice(index, 1)

      if (this.departamentos.length === 0) {
        this.adicionaResponsaveisDepartamento()
      }
    },
    adicionaComoPrimeiro() {
      const ultimoAdicionado = this.departamentos[this.departamentos.length - 1]
      this.departamentos.splice(this.departamentos.length - 1, 1)
      this.departamentos.splice(0, 0, ultimoAdicionado)
    },
  },
}
</script>
